export default "/_next/static/4e0bc41eeee7a24073903a2d052f0f8d.png";